import * as React from "react";

import { cn } from "@/lib/utils";

interface ProgressProps extends React.ComponentProps<"div"> {
    value?: number;
    indicatorClassName?: string;
}

function Progress({
    className,
    value = 0,
    indicatorClassName,
    ...props
}: ProgressProps) {
    return (
        <div
            data-slot="progress"
            className={cn(
                "relative h-2 w-full overflow-hidden rounded-full bg-primary/20",
                className
            )}
            {...props}
        >
            <div
                data-slot="progress-indicator"
                className={cn(
                    "h-full w-full flex-1 bg-primary transition-all",
                    indicatorClassName
                )}
                style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
            />
        </div>
    );
}

export { Progress };
